import { baseApi } from './baseApi'
import type {
  Bank,
  BankListQuery,
  DataResponse,
  MessageResponse,
  PageResponse,
} from '@/types/api'

export const banksApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listBanks: b.query<PageResponse<Bank>, BankListQuery | void>({
      query: (params) => ({ url: '/purchase/refs/banks/list', params: params ?? {} }),
      providesTags: (res) =>
        res
          ? [
              ...res.items.map((bk) => ({ type: 'Bank' as const, id: bk.bank_code })),
              { type: 'Bank' as const, id: 'LIST' },
            ]
          : [{ type: 'Bank' as const, id: 'LIST' }],
    }),
    createBank: b.mutation<DataResponse<Bank>, Bank>({
      query: (body) => ({ url: '/purchase/refs/banks/create', method: 'POST', body }),
      invalidatesTags: [{ type: 'Bank', id: 'LIST' }],
    }),
    updateBank: b.mutation<DataResponse<Bank>, { bank_code: string; body: Partial<Bank> }>({
      query: ({ bank_code, body }) => ({
        url: `/purchase/refs/banks/${encodeURIComponent(bank_code)}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_r, _e, arg) => [
        { type: 'Bank', id: arg.bank_code },
        { type: 'Bank', id: 'LIST' },
      ],
    }),
    deleteBank: b.mutation<MessageResponse, string>({
      query: (bank_code) => ({
        url: `/purchase/refs/banks/${encodeURIComponent(bank_code)}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Bank', id: 'LIST' }],
    }),
  }),
})

export const {
  useListBanksQuery,
  useCreateBankMutation,
  useUpdateBankMutation,
  useDeleteBankMutation,
} = banksApi
